<template>
    <b-card class="report-card h-100">
        <b-card-body
            class="d-flex h-100 align-items-center justify-content-between"
        >
            <h4 class="d-inline-block mr-3">{{ report.title }}</h4>
            <i :class="['text-34 float-right text-dark', report.icon]"></i>
        </b-card-body>
    </b-card>
</template>

<script>
export default {
    name: 'HappinessReportsCard',
    props: {
        report: {
            type: Object,
        },
    },
}
</script>

<style lang="scss">
.report-card {
    &:hover {
        box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15) !important;
    }
}
</style>
